import React from "react";
import { LabelItem, MyCard } from "../ProfileUI";
import {
  EnrollmentStdType,
  StudentIDFormat,
  TransferType,
} from "../../../../../Library/GlobalHelper";
import moment from "moment";

export function StdAcad({ student }) {
  let enrollment = "";
  let transfer_type = "";
  if (student.enrollment_type_id) {
    enrollment = EnrollmentStdType(student.enrollment_type_id);
  }

  if (student.transfer_type_id) {
    transfer_type = TransferType(student.transfer_type_id);
  }

  const semester_status = student.semester_status;
  const total_semes = Object.values(semester_status).length;
  const current_semester = semester_status[total_semes - 1];

  return (
    <MyCard>
      <div className="pt-8">
        <h3 className="mb-5">Academic Overview</h3>
        <div className="row">
          <div className="col-12 col-lg-6 col-xxl-6">
            <LabelItem
              name={"Status"}
              value={student.status && (student.status?.name || "-")}
            />
            {student.yudisium_date && (
              <LabelItem
                name={"Yudisium Date"}
                value={moment(student.yudisium_date).format("Do MMM YYYY")}
              />
            )}
            <LabelItem
              name={"Student ID"}
              value={
                student.studentid && (StudentIDFormat(student.studentid) || "-")
              }
            />
            <LabelItem
              name={"Cumulative Credit Summary"}
              value={(student?.ccredit_gpa || "0") + " SKS"}
            />
            <LabelItem
              name={"Cumulative Earned Credit"}
              value={(student?.ccredit_pass || "0") + " SKS"}
            />
            <LabelItem name={"Cumulative GPA"} value={student?.cgpa || "0"} />
            <LabelItem
              name={"Current Semester"}
              value={current_semester && (current_semester?.semester || "0")}
            />
            <LabelItem
              name={"Current Semester Credit"}
              value={
                current_semester &&
                (current_semester?.credit_all || "0") + " SKS"
              }
            />
            <LabelItem
              name={"CPDP Point"}
              value={`${student.cpdp_point}/100 ${student.cpdp_point >= 100 ? 'COMPLETED' : 'INCOMPLETED'}`}
            />
          </div>
          <div className="col-12 col-lg-6 col-xxl-6">
            <LabelItem
              name={"Term Intake"}
              value={student.term_intake && (student.term_intake?.name || "-")}
            />
            <LabelItem name={"Enrollment Type"} value={enrollment} />
            <LabelItem name={"Transfer Type"} value={transfer_type || "-"} />
            <LabelItem
              name={"Curriculum"}
              value={student.curr && (student.curr?.name || "-")}
            />
            <LabelItem
              name={"Program"}
              value={student.program && (student.program?.name || "-")}
            />
            <LabelItem
              name={"Degree Type"}
              value={student?.degree_type?.name || (student.ddegree === 0 ? 'Single Degree' : 'Double Degree')}
            />

            <LabelItem
              name={"Department"}
              value={
                student.clu_spec &&
                `${student.clu_spec?.name || "-"} (${student.clu_spec?.code || "-"
                })`
              }
            />
            {student.corporate && student.corporate.id && student.corporate.id !== 3 && (
              <LabelItem
                name={"Corporate"}
                value={student.corporate && (student.corporate.name || "-")}
              />
            )}
            <LabelItem name={"SGU Mail"} value={student.sgumail || "-"} />
          </div>
        </div>
      </div>
    </MyCard>
  );
}
